import { useMemo } from 'react'

export const useMenuStyles = () => {
  return useMemo(
    () => ({
      leftMenuWidth: 344,
      leftMenuLgWidth: 288,
      leftMenuPaddingRight: 96,
    }),
    []
  )
}
